import React from 'react';

const Hero = () => {
  return (
    <section className="hero">{/* Enhanced Background */}
      <div className="background-elements">
        <div className="grid-mesh"></div>
        <div className="glow-spot spot-1"></div>
        <div className="glow-spot spot-2"></div>
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>

      <div className="hero-container">
        {/* Left Content */}
        <div className="hero-content">
          <div className="content-wrapper">
            {/* Enhanced Glass Badge */}
            <div className="hero-badge ultra-glass">
              <div className="badge-shine"></div>
              <span>Creator-Led Growth Agency</span>
            </div>

            {/* White Title with Enhanced Typography */}
            <h1 className="hero-title">
              <span className="title-line main">A Dedicated</span>
              <span className="title-line accent">Strategic Growth Partner</span>
            </h1>

            <p className="hero-description">
              We help Web3 projects plan, launch, and scale through go-to-market
              strategy, content distribution, and ecosystem partnerships—connecting
              you with the right creators and communities.
            </p>

            {/* Refined Glass Buttons */}
            <div className="hero-actions">
              <button
                className="cta-button ultra-glass primary"
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                <span className="btn-shine"></span>
                Start Your Journey
              </button>
              <button
                className="cta-button ultra-glass secondary"
                onClick={() => document.getElementById('case-studies')?.scrollIntoView({ behavior: 'smooth' })}
              >
                <span className="btn-shine"></span>
                View Our Work
              </button>
            </div>
          </div>
        </div>

        {/* Enhanced Logo Section */}
        <div className="hero-logo">
          <div className="logo-container">
            <div className="logo-platform ultra-glass"></div>
            <img
              src="/logos/gaminggrid-logo.gif"
              alt="GamingGrid Agency"
              className="spinning-logo"
            />
            <div className="logo-glow"></div>
            <div className="logo-orbits">
              <div className="orbit orbit-1"></div>
              <div className="orbit orbit-2"></div>
              <div className="orbit orbit-3"></div>
              <div className="floating-dot dot-1"></div>
              <div className="floating-dot dot-2"></div>
              <div className="floating-dot dot-3"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator" onClick={() => document.getElementById('partners')?.scrollIntoView({ behavior: 'smooth' })}>
        <span className="scroll-text">Scroll to explore</span>
        <div className="scroll-icon">
          <div className="mouse">
            <div className="mouse-wheel"></div>
          </div>
          <div className="scroll-arrows">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="7 13 12 18 17 13"></polyline>
            </svg>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="7 13 12 18 17 13"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;